import { useSettingShopToBuyLoggedOut } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingShopToBuyLoggedOut";
import { ActionVariant } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/select-payment-terms/SelectNetTermsStep";
import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

interface IProps {
  isLoading: boolean;
  onClickSccApplication: () => void;
  onSubmit: () => void;
  actionVariant: ActionVariant;
}

export const PrimaryAction: React.FC<IProps> = ({
  isLoading,
  onClickSccApplication,
  onSubmit,
  actionVariant,
}) => {
  if (actionVariant === "SCC_LIMIT_INCREASE_EXPERIMENT") {
    return (
      <Button onClick={onClickSccApplication} data-test-id="scc-application">
        <StrictLocalMsg
          id="xM8BdT"
          defaultMessage="Request higher terms"
          description={{
            text: "Button to request higher terms",
            img: "https://cdn.faire.com/fastly/f25842d597327c0c85793ebcd169a31fadb92c97533cb3b0f977f0b140db5283.png",
          }}
        />
      </Button>
    );
  }

  return (
    <Button
      loading={isLoading}
      onClick={onSubmit}
      data-test-id="select-payment-terms"
    >
      <CTATextElement actionVariant={actionVariant} />
    </Button>
  );
};

const CTATextElement: React.FC<{
  actionVariant: ActionVariant;
}> = ({ actionVariant }) => {
  const isShopToBuyLoggedOut = useSettingShopToBuyLoggedOut();

  if (actionVariant === "UPMARKET_QUALIFIED") {
    if (isShopToBuyLoggedOut) {
      return (
        <StrictLocalMsg
          id="8wTm52"
          defaultMessage="Start buying"
          description={{
            text: "Button for retailer to start buying on Faire",
            img: "https://cdn.faire.com/fastly/7786b4d22d5c17f3415a3120ba86c06c9cd380b63ff836ada8d6714fd539b8cd.png",
          }}
        />
      );
    }
    return (
      <StrictLocalMsg
        id="Qr6UvG"
        defaultMessage="Start shopping"
        description={{
          text: "Button for retailer to start shopping",
          img: "https://cdn.faire.com/fastly/a5fd469e16d735cad25384d828655da96677caa9ecc4f9953719666d7c0482e5.png",
        }}
      />
    );
  }

  if (actionVariant === "REAL_TIME_TERMS_OWF") {
    return (
      <StrictLocalMsg
        id="ryY7fq"
        defaultMessage="Next"
        description={{
          text: "Button to go to next step",
          img: "https://cdn.faire.com/fastly/d206afa5280ea355acb9b7a96a5812157a573fd6cd83e7eb1833158348cd7aea.png",
        }}
      />
    );
  }

  if (actionVariant === "OPEN_WITH_FAIRE_ELIGIBLE") {
    return (
      <StrictLocalMsg
        id="xM8BdT"
        defaultMessage="Request higher terms"
        description={{
          text: "Button to request higher terms",
          img: "https://cdn.faire.com/fastly/f25842d597327c0c85793ebcd169a31fadb92c97533cb3b0f977f0b140db5283.png",
        }}
      />
    );
  }

  return (
    <StrictLocalMsg
      id="FsxS45"
      defaultMessage="Shop with payment terms"
      description={{
        text: "Button to select to shop with payment terms",
        img: "https://cdn.faire.com/fastly/ee58f6a470130806b26663ed1eaff1a92135ec4c6f5f4a425e46f4af13bd0206.png",
      }}
    />
  );
};
